package com.example.mystybag.login.logic

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.NavigatorConfig
import com.example.mystybag.core.logic.base.MainCallback
import com.example.mystybag.login.logic.LoginInterface
import com.example.mystybag.login.logic.NavigatorAddMerchantLocationFromDashboard
import com.example.mystybag.login.model.AddLocationPromptUIState

class AddLocationPromptViewModel(
    context: AppContext,
    private val config: NavigatorAddLocationPrompt
) : ChildViewModel<AddLocationPromptUIState>(context, AddLocationPromptUIState()), LoginInterface {
    
    override fun goToMainScreen(showProgress: Boolean, onErrorCallback: (() -> Unit)?, target: NavigatorConfig?) {
        setResult<LoginInterface> { goToMainScreen(showProgress, onErrorCallback, target) }
    }

    override fun onCreate() {
        navControls.backButtonVisible = false // Don't allow going back from this screen
    }

    fun onGetStarted() {
        // Navigate to the location creation process via MainCallback
        // This allows MystyBagDigitalWalletViewModel to handle NavigatorAddMerchantLocationFromDashboard
        setResult<MainCallback> {
            popToMainAndNavigate(
                NavigatorAddMerchantLocationFromDashboard(
                    merchantId = config.merchantId,
                    companyPhoneNumber = config.companyPhoneNumber,
                    companyDialCode = config.companyDialCode,
                    registeredCompanyStreet = config.registeredCompanyStreet,
                    registeredCompanyCityId = config.registeredCompanyCityId,
                    registeredCompanyCityName = config.registeredCompanyCityName
                )
            )
        }
    }
}
